<div class="home-page">
  <div class="banner-area">
    <div class="container-banner">
      <app-slide-banner></app-slide-banner>
    </div>
  </div>

  <div id="dobra"></div>
  <div>
    <section class="first-section">
      <div class="container">
        <div class="container-box-gray">
          <div>
            <div class="col-md-9 m-auto">
              <h4>Com azulzinha você tem mais possibilidades para crescer</h4>
              <p style="font-size: 16px" class="col-md-8 mx-auto my-4">
                Empreenda com as soluções CAIXA em parceria com a Fiserv, líder
                global em tecnologias de pagamentos e serviços financeiros.
              </p>
            </div>
            <div class="container-cards row">
              <div class="card-gray col-md-3 col-6">
                <img [lazyLoad]="'assets/img/icons/lupa.svg'" alt="" />
                <p>Soluções para lojas físicas e venda online.</p>
              </div>
              <div class="card-gray col-md-3 col-6">
                <img [lazyLoad]="'assets/img/icons/graphic2.svg'" alt="" />
                <p>Serviços agregados para impulsionar suas vendas.</p>
              </div>
              <div class="card-gray col-md-3 col-6">
                <img
                  [lazyLoad]="'assets/img/icons/seguranca-note.svg'"
                  alt=""
                />
                <p>Plataformas robustas e seguras para grandes comércios.</p>
              </div>
              <div class="card-gray col-md-3 col-6">
                <img [lazyLoad]="'assets/img/icons/icon-graphic.svg'" alt="" />
                <p>Ferramentas completas de gestão em tempo real.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-img">
        <img [lazyLoad]="'assets/img/hero-banner.png'" alt="" />
      </div>
    </section>

    <section class="componente-text-img">
      <div class="container">
        <header class="isMobile">
          <h2>Com azulzinha você tem mais facilidade para gerir</h2>
          <p>
            Com o apoio do <a routerLink="">App da azulzinha</a> e do
            <a href="">Portal da azulzinha</a> no dia a dia, você tem
            ferramentas completas para gerenciar seu negócio com mais
            simplicidade.
          </p>
        </header>
        <app-block-text-img>
          <ng-container contentText>
            <header>
              <h2>Com azulzinha você tem mais apoio para empreender</h2>
              <p class="col-xl-9 mt-4">
                Tenha muito mais tranquilidade para transformar o seu comércio e
                impulsionar as vendas com agilidade e segurança. 
              </p>
            </header>
            <ul class="mt-5">
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icone-cartao2.svg'"
                  alt=""
                />Trabalhe com as principais bandeiras, vouchers e carteiras
                digitais.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icone-cartao.svg'"
                  alt=""
                />Receba suas vendas em até 2 dias úteis.
              </li>

              <li>
                <img
                  [lazyLoad]="'assets/img/icons/cartao-nfc.svg'"
                  alt=""
                />Aceite pagamentos com débito, crédito, aproximação e QR Code.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icone-cel-home.svg'"
                  alt=""
                />Transforme celulares em maquininhas.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icone-nfc.svg'"
                  alt=""
                />Integre, centralize e concilie as vendas num lugar só.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icone-tela.svg'"
                  alt=""
                />Controle suas vendas de forma simples e rápida.
              </li>
            </ul>
            <div class="cta-link mt-5">
              <a class="linkHover" routerLink="/peca-azulzinha"
                >Peça a sua azulzinha</a
              >
              <img
                style="margin-left: 10px"
                src="assets/img/seta-direita2.png"
                alt=""
              />
            </div>
          </ng-container>
          <ng-container contentImg>
            <div class="container-img">
              <div class="bg-img-two"></div>
              <div class="img-two">
                <picture>
                  <source
                    media="(max-width: 765px)"
                    srcset="assets/img/group-maquinas.png"
                  />
                  <img
                    class="img-fluid"
                    src="assets/img/group-maquinas.png"
                    alt=""
                  />
                </picture>
              </div>
            </div>
          </ng-container>
        </app-block-text-img>
      </div>
    </section>

    <section>
      <div class="container container-bandeiras">
        <div class="header-bandeiras">
          <h2>
            Venda com mais de 40 bandeiras nacionais, internacionais, regionais
            e vouchers
          </h2>
          <p>
            A azulzinha já vem com a maior variedade de bandeiras de débito e
            crédito e muitas opções para você habilitar.
          </p>
        </div>
        <div class="content-bandeiras">
          <div class="bandeira" *ngFor="let item of bandeiras">
            <img [lazyLoad]="item" alt="" />
          </div>
        </div>

        <div class="cta-link">
          <a routerLink="/bandeiras-vouchers">Consulte todas as bandeiras</a>
          <img [lazyLoad]="'assets/img/seta-direita2.png'" alt="" />
        </div>
      </div>
    </section>

    <section class="carousel">
      <div class="container container-swiper">
        <header class="text-center col-md-9 m-auto">
          <h2>
            Incremente seu negócio com serviços exclusivos ideais para você e
            seu estabelecimento
          </h2>
          <p>
            Cliente azulzinha também pode antecipar o recebimento das vendas,
            transformar o celular em maquininha, vender por Pix, online e muito
            mais!
          </p>
        </header>
        <swiper
          class="container-card-swiper"
          [slidesPerView]="3"
          [spaceBetween]="0"
          [navigation]="true"
          [breakpoints]="configCarrossel"
        >
          <ng-template *ngFor="let item of cards" swiperSlide>
            <app-card-component [Items]="item"></app-card-component>
          </ng-template>
        </swiper>

        <div class="text-center mt-5">
          <a
            class="btn btn-primary rounded-none btn-big"
            routerLink="/peca-azulzinha"
            >Solicite a sua azulzinha</a
          >
        </div>
      </div>
    </section>

    <section class="componente-text-img">
      <div class="container">
        <header class="isMobile">
          <h2>Com azulzinha você tem mais facilidade para gerir</h2>
          <p>
            Com o apoio do <a routerLink="">App da azulzinha</a> e do
            <a routerLink="/portal">Portal da azulzinha</a> no dia a dia, você
            tem ferramentas completas para gerenciar seu negócio com mais
            simplicidade.
          </p>
        </header>
        <app-block-text-img [left]="true">
          <ng-container contentText>
            <header>
              <h2>Com azulzinha você tem mais facilidade para gerir</h2>
              <p>
                Com o apoio do <a routerLink="">App da azulzinha</a> e do
                <a href="">Portal da azulzinha</a> no dia a dia, você tem
                ferramentas completas para gerenciar seu negócio com mais
                simplicidade.
              </p>
            </header>
            <ul>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icon-vision.svg'"
                  alt=""
                />Tenha visão estratégica das vendas e pagamentos.
              </li>
              <li>
                <img [lazyLoad]="'assets/img/icons/icon-agil.svg'" alt="" />Faça
                a antecipação do seu dinheiro e receba em até 2 dias, sem
                burocracia.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icon-graphic3.svg'"
                  alt=""
                />Automatize relatórios personalizados.
              </li>
              <li>
                <img
                  [lazyLoad]="'assets/img/icons/icon-chat2.svg'"
                  alt=""
                />Solicite bobinas e habilite mais serviços.
              </li>
            </ul>
            <div class="cta">
              <a
                class="btn btn-primary rounded-none btn-big"
                routerLink="/portal"
                >Saiba mais</a
              >
            </div>
          </ng-container>
          <ng-container contentImg>
            <div class="container-img">
              <div class="bg-img-one"></div>
              <div class="img-one">
                <picture>
                  <source
                    media="(max-width: 765px)"
                    srcset="assets/img/img-portal-bg.png"
                  />
                  <img
                    class="img-fluid"
                    src="assets/img/img-portal.png"
                    alt=""
                  />
                </picture>
              </div>
            </div>
          </ng-container>
        </app-block-text-img>
      </div>
    </section>

    <section>
      <div class="footer-cta row align-items-center mx-0">
        <div class="diagonal-img col-md">
          <div class="content-text col-md">
            <h4>Com azulzinha da CAIXA você pode muito mais!</h4>
            <p class="col-md-8 mx-auto mt-2">
              Conte com as melhores taxas e condições para crescer, gerir e
              prosperar com seu negócio.
            </p>
            <div class="mt-4">
              <a
                class="btn btn-primary btn-big rounded-none"
                routerLink="/peca-azulzinha"
                >Peça já a sua</a
              >
            </div>
          </div>
        </div>
        <div class="col-md img-diagonal">
          <img class="img-fluid" src="assets/img/mask-img-bg.png" alt="" />
        </div>
      </div>
      <div class="mobile-footer-cta">
        <div class="content">
          <h4>Com azulzinha da CAIXA você pode muito mais!</h4>
          <p class="col-md-3">
            Conte com as melhores taxas e condições para crescer, gerir e
            prosperar com seu negócio.
          </p>
          <div>
            <a class="btn btn-primary rounded-none" routerLink="/peca-azulzinha"
              >Peça já a sua</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
